module.exports = __webpack_public_path__ + "static/media/toiletDefault.23980ab2.png";